import { Heart } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import { useToast } from '../hooks/use-toast';

export default function WishlistButton({ product, className = '', size = 'w-4 h-4' }) {
  const { has, toggle } = useWishlist();
  const { toast } = useToast();
  const active = has(product.id);

  const onClick = async (e) => {
    e.preventDefault(); e.stopPropagation();
    const added = await toggle(product);
    toast({ title: added ? 'Saved to your wishlist' : 'Removed from wishlist', description: product.name });
  };

  return (
    <button
      type="button"
      data-testid={`wishlist-btn-${product.id}`}
      aria-label={active ? 'Remove from wishlist' : 'Save to wishlist'}
      aria-pressed={active}
      onClick={onClick}
      className={`flex items-center justify-center transition-transform duration-300 active:scale-90 ${className}`}
    >
      <Heart className={`${size} transition-colors duration-300 ${active ? 'fill-[#C6410E] text-[#C6410E]' : 'text-[#1a1a1a]'}`} />
    </button>
  );
}
